export enum EOrderDirectionType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type OrderDirectionType = EOrderDirectionType.ASC | EOrderDirectionType.DESC;

export type OrderByType = {
  field: string;
  direction: OrderDirectionType;
};

export type OrderByFields = Record<string, OrderByType>;
